module.exports = __webpack_public_path__ + "static/media/iStock-1170697662.1cc8028c.jpg";